module.exports = __webpack_public_path__ + "img/lottery.a7392995.png";